// Implementamos los estilos de la modal (la modal que unificó todas las modales).
export function addStylesModal() {
    const linkStyle = document.createElement("link");
    linkStyle.rel = 'stylesheet';
    linkStyle.href = "https://static.womtp.com/slider/c/mapfre/es/cssModalsLanding/globalModalStyles.css";
    linkStyle.type = "text/css";

    // document.head.appendChild(linkStyle);
    const headElement = document.getElementsByTagName('head')[0];
    headElement.appendChild(linkStyle);
}


// WEBPACK FOOTER //
// ./js/utils/modal/handleStylesModal.js